// extracted by mini-css-extract-plugin
export var typingIndicator = "_ru-0";